<template>
  
  <dialog_customerPicker @submit="handleCustomerSubmit" v-if="CustomerPickerVisible" />
  <dialog_counselHistory v-if="historyVisible" :oth_close="() => historyVisible = false" />

  <div id="dialog-counsel">
    <span class="cls" @click="oth_showInsuConsule(false)"></span>
    <div class="paper">

      <!-- 헤더 -->
      <div class="header">
        <span class="nav-btn" @click="handleBack()"><i class="ph ph-caret-left"></i></span>
        <h1>{{ isPracticeMode ? '상담 연습' : '보험 상담' }}</h1>
        <span class="nav-btn close" @click="oth_showInsuConsule(false)"><i class="ph ph-x"></i></span>
      </div>

      <!-- 첫 화면: 상담 시작 -->
      <div class="content first" v-if="!isPracticeMode && selectCustomer === null">
        <div class="welcome-card">
          <div class="logo-wrap">
            <img src="/imgs/LOGO.png"/>
            <div class="logo-glow"></div>
          </div>
          <h2>어떤 상담을 도와드릴까요?</h2>
          <p class="subtitle">고객에게 맞춤형 보험 상담을 시작하세요</p>
        </div>
        <div class="btns">
          <button @click="CustomerPickerShow(true)" class="main">
            <i class="ph ph-chat-circle-dots"></i>
            상담하기
          </button>
          <div class="sub-btns">
            <button @click="startPracticeMode()">
              <i class="ph ph-graduation-cap"></i>
              연습
            </button>
            <!-- <button disabled>
              <i class="ph ph-pencil-line"></i>
              보장스케치
            </button> -->
            <button @click="historyVisible = true">
              <i class="ph ph-clock-counter-clockwise"></i>
              상담이력
            </button>
          </div>
        </div>
      </div>


      <!-- 두번째 화면: 상담 선택 -->
      <div class="content second" v-if="(selectCustomer != null || isPracticeMode) && selectConsultation === null">
        <div class="list-set">
          <div class="list-header">
            <h2>
              <i class="ph ph-star"></i> 
              {{ isPracticeMode ? '연습할 상담 선택' : '자주 사용함' }}
            </h2>
          </div>
          <ul>
            <li v-for="(counsel, index) in counselList" :key="index" @click="choseConsultation(counsel)">
              <div class="thumb">
                <img :src="counsel.cover"/>
              </div>
              <div class="info">
                <h3>{{counsel.title}}</h3>
                <span class="desc">{{counsel.description}}</span>
                <div class="meta">
                  <span class="stat"><i class="ph ph-users"></i> 12,222</span>
                  <span class="badge">인기</span>
                </div>
              </div>
              <i class="ph ph-caret-right arrow"></i>
            </li>
          </ul>
        </div>
      </div>


      <!-- 상담 진행 슬라이드 -->
      <swiper 
        class="content-large"
        @swiper="onSwiper"
        :allow-touch-move="false"
        :simulate-touch="false"
        v-if="(selectCustomer != null || isPracticeMode) && selectConsultation != null && allSlides.length > 0">

        <swiper-slide v-for="(page, index) in allSlides" :key="'slide-' + index">
          
          <!-- 자기소개 슬라이드 -->
          <template v-if="page.type === 'intro'">
            <div class="slide-paper intro-slide">
              <div class="intro-content">
                <div class="intro-avatar">
                  <img :src="member_info?.image || '/imgs/default-avatar.png'" />
                </div>
                <h1>안녕하세요, {{ isPracticeMode ? '고객' : selectCustomer.name }}님!</h1>
                <p class="intro-text">
                  저는 <strong>{{ member_info?.name || '보험설계사' }}</strong>입니다.<br>
                  오늘 {{ isPracticeMode ? '고객' : selectCustomer.name }}님께 꼭 맞는 보험을 찾아드릴게요.
                </p>
                <button class="intro-start-btn" @click="swiperNext()">
                  <span>상담 시작하기</span>
                  <i class="ph ph-arrow-right"></i>
                </button>
              </div>
            </div>
          </template>

          <!-- 일반 상담 슬라이드 -->
          <template v-else>
            <div class="slide-paper" @click="!page.question && swiperNext()">
              <div class="slide-content">
                <div class="image-wrap" v-if="page.image">
                  <img :src="page.image" />
                </div>
                <h1>{{ page.content }}</h1>
                <p class="question" v-if="page.question">{{ page.question }}</p>
                <div class="answers" v-if="page.options && page.options.length > 0">
                  <button
                    v-for="(option, oindex) in page.options"
                    :key="oindex"
                    @click.stop="answerQuestion(page.idx, oindex)"
                    :class="{ active: answered[page.idx] === oindex }"
                  >
                    <span class="option-indicator">{{ String.fromCharCode(65 + oindex) }}</span>
                    {{ option.option_text }}
                  </button>
                </div>
                <button 
                  v-if="page.question && answered[page.idx] != null" 
                  class="next-btn"
                  @click.stop="swiperNext()">
                  다음 <i class="ph ph-arrow-right"></i>
                </button>
              </div>
            </div>

            <!-- 힌트 버튼 -->
            <button class="hint-btn" v-if="page.memo" @click="page.hint_visible = true">
              <i class="ph ph-question"></i>
            </button>

            <!-- 힌트 모달 -->
            <Transition name="fade">
              <div class="hint-overlay" v-if="page.hint_visible">
                <span class="cls" @click="page.hint_visible = false"></span>
                <div class="hint-card">
                  <div class="hint-header">
                    <i class="ph ph-lightbulb"></i>
                    <h2>힌트</h2>
                  </div>
                  <p>{{ page.memo }}</p>
                  <button class="hint-close" @click="page.hint_visible = false">확인</button>
                </div>
              </div>
            </Transition>
          </template>
        </swiper-slide>

        <!-- 결과 슬라이드 -->
        <swiper-slide>
          <div class="slide-paper result">
            <div class="result-header">
              <i class="ph ph-check-circle"></i>
              <h2>{{ isPracticeMode ? '연습 완료' : '상담 완료' }}</h2>
            </div>
            <div class="result-summary">
              <p v-if="isPracticeMode">상담 연습이 완료되었습니다.</p>
              <p v-else>{{ selectCustomer.name }}님과의 상담이 완료되었습니다.</p>
            </div>
            <div class="result-list">
              <template v-for="page in selectCounselPage" :key="page.idx">
                <div class="result-item" v-if="page.question && getAnswerText(page)">
                  <span class="q-label">Q</span>
                  <div class="result-content">
                    <p class="result-q">{{ page.question }}</p>
                    <p class="result-a">{{ getAnswerText(page) }}</p>
                  </div>
                </div>
              </template>
            </div>
            <div class="result-actions">
              <button class="result-btn secondary" @click="oth_showInsuConsule(false)">
                <i class="ph ph-x"></i> 닫기
              </button>
              <button v-if="!isPracticeMode" class="result-btn primary" @click="saveAndClose()">
                <i class="ph ph-floppy-disk"></i> 저장 후 닫기
              </button>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <!-- 진행 인디케이터 -->
      <div class="progress-bar" v-if="selectConsultation != null && swiperInstance">
        <div class="progress-fill" :style="{ width: progressPercent + '%' }"></div>
      </div>

    </div>
  </div>  
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import "swiper/swiper-bundle.min.css";
import { ref, inject, onMounted, computed } from 'vue';

import dialog_customerPicker from './customerPicker.vue';
import dialog_counselHistory from './insuCounselHistory.vue';
import { useBackButton } from '@/utils/useBackBtn';

export default ({
  components: {
    Swiper,
    SwiperSlide,
    dialog_customerPicker,
    dialog_counselHistory
  },
  props: {
    oth_showInsuConsule: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const member_info = inject('member_info');
    const selectCustomer = ref(null);
    const selectConsultation = ref(null);
    const counselList = ref([]);
    const selectCounselPage = ref([]);
    const swiperInstance = ref(null);
    const CustomerPickerVisible = ref(false);
    const historyVisible = ref(false);
    const currentSlide = ref(0);
    const isPracticeMode = ref(false);

    useBackButton(() => {
      props.oth_showInsuConsule(false);
    });

    const answered = ref({});

    const allSlides = computed(() => {
      if (!selectCounselPage.value.length) return [];
      return [
        { type: 'intro' },
        ...selectCounselPage.value.map(p => ({ ...p, type: 'content' }))
      ];
    });

    const progressPercent = computed(() => {
      if (!swiperInstance.value || !allSlides.value.length) return 0;
      const total = allSlides.value.length + 1;
      return ((currentSlide.value + 1) / total) * 100;
    });

    function answerQuestion(pageIdx, optionIdx) {
      answered.value[pageIdx] = optionIdx;
    }

    function CustomerPickerShow(bool) {
      CustomerPickerVisible.value = bool;
    }

    function handleCustomerSubmit({customer}) {
      CustomerPickerShow(false);
      if (customer) {
        selectCustomer.value = customer;
      }
    }

    // 연습 모드 시작
    function startPracticeMode() {
      isPracticeMode.value = true;
    }

    // 뒤로가기 처리
    function handleBack() {
      if (selectConsultation.value) {
        // 상담 진행 중 → 상담 선택으로
        selectConsultation.value = null;
        selectCounselPage.value = [];
        answered.value = {};
        currentSlide.value = 0;
      } else if (selectCustomer.value || isPracticeMode.value) {
        // 상담 선택 → 첫 화면으로
        selectCustomer.value = null;
        isPracticeMode.value = false;
      }
    }

    async function fetchConsultations() {
      const res = await sql_query(`SELECT * FROM insu_counsel_set ORDER BY created_at DESC`);
      return res;
    }

    async function choseConsultation(counsel) {
      selectConsultation.value = counsel;
      selectCounselPage.value = await fetchCounselPage();
      await fetchPageOptions();
    }

    async function fetchCounselPage() {
      let pack = [];
      if (selectConsultation.value) {
        selectConsultation.value.counsel_list = JSON.parse(selectConsultation.value.counsel_list || '[]');

        for (const element of selectConsultation.value.counsel_list) {
          const sql = `SELECT * FROM insu_counsel_page WHERE counsel_idx=${element.counsel_idx} ORDER BY page_no ASC;`;
          const res = await sql_query(sql);
          element.pages = res.map(row => ({
            ...row,
            hint_visible: false
          }));
          pack.push(...element.pages);
        }

        return pack;
      }
      return [];
    }

    async function fetchPageOptions() {
      if (selectCounselPage.value) {
        for (const page of selectCounselPage.value) {
          const res = await sql_query(`SELECT * FROM insu_counsel_page_option WHERE page_idx=${page.idx} ORDER BY option_no ASC;`);
          page.options = res;
        }
      }
    }

    function onSwiper(swiper) {
      swiperInstance.value = swiper;
      swiper.on('slideChange', () => {
        currentSlide.value = swiper.activeIndex;
      });
    }

    function swiperNext() {
      swiperInstance.value?.slideNext();
    }

    function swiperPrev() {
      if (currentSlide.value === 0) return;
      swiperInstance.value?.slidePrev();
    }

    async function saveAndClose() {
      if (!member_info?.mb_id || !selectCustomer.value || !selectConsultation.value) {
        props.oth_showInsuConsule(false);
        return;
      }

      const answersJson = JSON.stringify(answered.value);
      
      await sql_query(`
        INSERT INTO insu_counsel_history 
        (mb_id, customer_idx, counsel_set_idx, answers, status, completed_at)
        VALUES ('${member_info.mb_id}', ${selectCustomer.value.idx}, 
                ${selectConsultation.value.idx}, '${answersJson}', 'completed', NOW())
      `);

      props.oth_showInsuConsule(false);
    }

    onMounted(async () => {
      counselList.value = await fetchConsultations();
    });

    function getAnswerText(page) {
      const sel = answered.value[page.idx];
      if (sel == null) return '';
      let opt = page.options?.find(o => o.option_no === sel + 1);
      return opt?.option_text ?? '';
    }

    return {
      selectCustomer,
      selectConsultation,
      CustomerPickerVisible,
      CustomerPickerShow,
      handleCustomerSubmit,
      fetchConsultations,
      counselList,
      choseConsultation,
      selectCounselPage,
      swiperNext,
      swiperPrev,
      onSwiper,
      swiperInstance,
      member_info,
      answerQuestion,
      answered,
      getAnswerText,
      progressPercent,
      currentSlide,
      allSlides,
      saveAndClose,
      isPracticeMode,
      startPracticeMode,
      handleBack,
      historyVisible
    };
  },
})
</script>


<style scoped>

/* ===== 기본 오버레이 ===== */
#dialog-counsel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

#dialog-counsel > .cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

/* ===== 메인 페이퍼 ===== */
.paper {
  width: 100%;
  max-width: 1100px;
  aspect-ratio: 16/10;
  background: var(--color-background);
  border-radius: 24px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== 헤더 ===== */
.header {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-background-light);
  flex-shrink: 0;
}

.header h1 {
  font-size: var(--font-size-lg);
  font-weight: 600;
  margin: 0;
}

.header .nav-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xl);
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.header .nav-btn:hover {
  background: var(--color-background-light);
}

.header .nav-btn.close:hover {
  background: rgba(218, 47, 71, 0.1);
  color: var(--color-special-warning);
}

/* ===== 진행 바 ===== */
.progress-bar {
  width: 100%;
  height: 4px;
  background: var(--color-background-light);
  flex-shrink: 0;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-brand), #FFD700);
  border-radius: 0 2px 2px 0;
  transition: width 0.4s ease;
}

/* ===== 첫 화면 (상담 시작) ===== */
.content.first {
  width: 100%;
  max-width: 480px;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  margin: 0 auto;
  gap: 32px;
}

.welcome-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.logo-wrap {
  position: relative;
  margin-bottom: 24px;
}

.logo-wrap img {
  width: 100px;
  height: 100px;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(255, 165, 0, 0.3);
}

.logo-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(255, 165, 0, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  z-index: -1;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.7; }
}

.welcome-card h2 {
  font-size: var(--font-size-xl);
  font-weight: 700;
  margin: 0 0 8px 0;
}

.welcome-card .subtitle {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
}

.content.first .btns {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.content.first button {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: var(--font-size-md);
  font-weight: 500;
  border-radius: 16px;
  border: none;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.25s ease;
}

.content.first button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.content.first button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.content.first button.main {
  height: 64px;
  background: linear-gradient(135deg, var(--color-brand), #FFD700);
  color: #000;
  font-weight: 700;
  font-size: var(--font-size-lg);
  box-shadow: 0 4px 20px rgba(255, 165, 0, 0.4);
}

.content.first button.main:hover {
  box-shadow: 0 8px 32px rgba(255, 165, 0, 0.5);
}

.content.first .sub-btns {
  display: flex;
  gap: 12px;
}

.content.first .sub-btns button {
  flex: 1;
  height: 52px;
  font-size: var(--font-size-sm);
}

/* ===== 두번째 화면 (상담 목록) ===== */
.content.second {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content.second .list-set {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.list-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--color-background-light);
}

.list-header h2 {
  font-size: var(--font-size-md);
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--color-brand);
}

.content.second ul {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.content.second li {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: var(--color-surface-light);
  border: 1px solid transparent;
}

.content.second li:hover {
  background: var(--color-background-light);
  border-color: var(--color-brand);
  transform: translateX(4px);
}

.content.second li .thumb {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
}

.content.second li .thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content.second li .info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.content.second li .info h3 {
  font-size: var(--font-size-md);
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.content.second li .info .desc {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.content.second li .meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.content.second li .stat {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.content.second li .badge {
  font-size: var(--font-size-xs);
  padding: 2px 8px;
  background: rgba(255, 165, 0, 0.15);
  color: var(--color-brand);
  border-radius: 100px;
  font-weight: 600;
}

.content.second li .arrow {
  font-size: var(--font-size-lg);
  color: var(--color-text-secondary);
  transition: transform 0.2s;
}

.content.second li:hover .arrow {
  transform: translateX(4px);
  color: var(--color-brand);
}

/* ===== 상담 슬라이드 ===== */
.content-large {
  width: 100%;
  flex: 1;
  overflow: hidden;
}

.content-large :deep(.swiper-wrapper) {
  height: 100%;
}

.content-large :deep(.swiper-slide) {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 24px;
  box-sizing: border-box;
}

.slide-paper {
  width: 100%;
  max-width: 600px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.slide-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}

.image-wrap {
  width: 80%;
  border-radius: 16px;
  aspect-ratio: 16/9;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.image-wrap img {
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.slide-content h1 {
  font-size: var(--font-size-xl);
  font-weight: 700;
  margin: 0;
  line-height: 1.4;
}

.slide-content .question {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  margin: 0;
}

/* ===== 자기소개 슬라이드 ===== */
.intro-slide {
  cursor: default;
}

.intro-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
}

.intro-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid var(--color-brand);
  box-shadow: 0 8px 32px rgba(255, 165, 0, 0.3);
}

.intro-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.intro-content h1 {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  margin: 0;
}

.intro-text {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin: 0;
}

.intro-text strong {
  color: var(--color-brand);
}

.intro-start-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  margin-top: 12px;
  background: linear-gradient(135deg, var(--color-brand), #FFD700);
  color: #000;
  border: none;
  border-radius: 16px;
  font-size: var(--font-size-md);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 20px rgba(255, 165, 0, 0.4);
}

.intro-start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(255, 165, 0, 0.5);
}

/* ===== 답변 버튼 ===== */
.answers {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.answers > button {
  flex: 1 1 calc(50% - 6px);
  min-width: 45%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 14px;
  border: 2px solid var(--color-background-light);
  font-size: var(--font-size-base);
  font-weight: 500;
  background: var(--color-background);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.25s ease;
}

.answers > button:hover {
  border-color: var(--color-brand);
  background: rgba(255, 165, 0, 0.05);
}

.answers > button.active {
  background: linear-gradient(135deg, var(--color-brand), #FFD700);
  border-color: var(--color-brand);
  color: #000;
  font-weight: 700;
  box-shadow: 0 4px 16px rgba(255, 165, 0, 0.3);
}

.option-indicator {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--color-background-light);
  font-size: var(--font-size-sm);
  font-weight: 700;
}

.answers > button.active .option-indicator {
  background: rgba(0, 0, 0, 0.2);
}

/* ===== 다음 버튼 ===== */
.next-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  margin-top: 16px;
  background: var(--color-brand);
  color: #000;
  border: none;
  border-radius: 12px;
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.next-btn:hover {
  filter: brightness(1.1);
  transform: translateX(4px);
}

/* ===== 힌트 버튼 & 모달 ===== */
.hint-btn {
  position: absolute;
  right: 24px;
  bottom: 24px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: var(--color-background-light);
  color: var(--color-brand);
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.hint-btn:hover {
  transform: scale(1.1);
  background: var(--color-brand);
  color: #000;
}

.hint-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.hint-overlay > .cls {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.hint-card {
  width: 90%;
  max-width: 400px;
  background: var(--color-background);
  padding: 28px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.hint-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  color: var(--color-brand);
}

.hint-header i {
  font-size: 28px;
}

.hint-header h2 {
  font-size: var(--font-size-lg);
  font-weight: 700;
  margin: 0;
}

.hint-card p {
  font-size: var(--font-size-base);
  line-height: 1.7;
  margin: 0 0 24px 0;
  color: var(--color-text-primary);
}

.hint-close {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  background: var(--color-brand);
  color: #000;
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.hint-close:hover {
  filter: brightness(1.1);
}

/* ===== 결과 슬라이드 ===== */
.slide-paper.result {
  max-width: 500px;
  cursor: default;
}

.result-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  color: var(--color-brand);
}

.result-header i {
  font-size: 36px;
}

.result-header h2 {
  font-size: var(--font-size-xl);
  font-weight: 700;
  margin: 0;
}

.result-summary {
  text-align: center;
  margin-bottom: 20px;
}

.result-summary p {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
}

.result-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 280px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.result-item {
  display: flex;
  gap: 12px;
  padding: 14px;
  background: var(--color-surface-light);
  border-radius: 12px;
  text-align: left;
}

.q-label {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-brand);
  color: #000;
  border-radius: 8px;
  font-weight: 700;
  font-size: var(--font-size-sm);
  flex-shrink: 0;
}

.result-content {
  flex: 1;
}

.result-q {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0 0 4px 0;
}

.result-a {
  font-size: var(--font-size-base);
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.result-actions {
  display: flex;
  gap: 12px;
  width: 100%;
}

.result-btn {
  flex: 1;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 12px;
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.result-btn.secondary {
  background: var(--color-background-light);
  color: var(--color-text-primary);
}

.result-btn.secondary:hover {
  background: var(--color-surface-light);
}

.result-btn.primary {
  background: linear-gradient(135deg, var(--color-brand), #FFD700);
  color: #000;
}

.result-btn.primary:hover {
  filter: brightness(1.1);
}

/* ===== 트랜지션 ===== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
/* ===== 태블릿 (601px ~ 1024px) ===== */
@media (min-width: 601px) and (max-width: 1024px) {
  #dialog-counsel {
    padding: 0 !important;
  }

  .paper {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    aspect-ratio: unset !important;
    border-radius: 0 !important;
  }

  .header {
    height: 56px;
    padding: 0 16px;
  }

  .header h1 {
    font-size: var(--font-size-base);
  }

  /* 첫 화면 */
  .content.first {
    padding: 32px;
    gap: 24px;
  }

  .logo-wrap img {
    width: 80px;
    height: 80px;
  }

  .welcome-card h2 {
    font-size: var(--font-size-lg);
  }

  .content.first button.main {
    height: 56px;
    font-size: var(--font-size-base);
  }

  .content.first .sub-btns button {
    height: 48px;
  }

  /* 상담 목록 - 2컬럼 그리드 */
  .content.second ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 16px;
  }

  .content.second li {
    flex-direction: column;
    align-items: flex-start;
    padding: 14px;
  }

  .content.second li .thumb {
    width: 100%;
    height: 100px;
    border-radius: 10px;
  }

  .content.second li .info {
    width: 100%;
  }

  .content.second li .info h3 {
    font-size: var(--font-size-base);
  }

  .content.second li .arrow {
    position: absolute;
    top: 14px;
    right: 14px;
  }

  /* 슬라이드 */
  .slide-content h1 {
    font-size: var(--font-size-lg);
  }

  .image-wrap {
    width: 70%;
  }

  .intro-avatar {
    width: 100px;
    height: 100px;
  }

  .intro-content h1 {
    font-size: var(--font-size-xl);
  }

  .answers > button {
    height: 50px;
    font-size: var(--font-size-sm);
  }

  /* 결과 */
  .result-list {
    max-height: 200px;
  }

  .hint-btn {
    width: 44px;
    height: 44px;
    font-size: 24px;
    right: 16px;
    bottom: 16px;
  }
}

/* ===== 태블릿 세로 (601px ~ 900px) ===== */
@media (min-width: 601px) and (max-width: 900px) {

  /* 상담 목록 1컬럼 */
  .content.second ul {
    grid-template-columns: 1fr;
  }

  .content.second li {
    flex-direction: row;
    align-items: center;
  }

  .content.second li .thumb {
    width: 72px;
    height: 72px;
  }

  .content.second li .arrow {
    position: static;
  }
}

/* ===== 모바일 (600px 이하) ===== */
@media (max-width: 600px) {

  .header {
    height: 52px;
    padding: 0 12px;
  }

  .header h1 {
    font-size: var(--font-size-base);
  }

  .header .nav-btn {
    width: 36px;
    height: 36px;
  }

  /* 첫 화면 */
  .content.first {
    padding: 24px 20px;
    gap: 24px;
  }

  .logo-wrap img {
    width: 72px;
    height: 72px;
    border-radius: 18px;
  }

  .logo-glow {
    width: 100px;
    height: 100px;
  }

  .welcome-card h2 {
    font-size: var(--font-size-lg);
  }

  .welcome-card .subtitle {
    font-size: var(--font-size-sm);
  }

  .content.first button.main {
    height: 56px;
    font-size: var(--font-size-base);
  }

  .content.first .sub-btns {
    gap: 8px;
  }

  .content.first .sub-btns button {
    height: 48px;
    font-size: var(--font-size-xs);
    padding: 0 8px;
  }

  /* 상담 목록 */
  .list-header {
    padding: 16px;
  }

  .list-header h2 {
    font-size: var(--font-size-base);
  }

  .content.second ul {
    padding: 12px;
    gap: 10px;
  }

  .content.second li {
    padding: 12px;
    gap: 12px;
  }

  .content.second li .thumb {
    width: 56px;
    height: 56px;
    border-radius: 10px;
  }

  .content.second li .info h3 {
    font-size: var(--font-size-base);
  }

  .content.second li .info .desc {
    font-size: var(--font-size-xs);
    -webkit-line-clamp: 1;
  }

  .content.second li .meta {
    gap: 8px;
  }

  /* 슬라이드 */
  .content-large :deep(.swiper-slide) {
    padding: 16px;
  }

  .slide-paper {
    max-width: 100%;
  }

  .slide-content {
    gap: 16px;
  }

  .slide-content h1 {
    font-size: var(--font-size-lg);
  }

  .slide-content .question {
    font-size: var(--font-size-sm);
  }

  .image-wrap {
    width: 100%;
    border-radius: 12px;
  }

  /* 자기소개 */
  .intro-avatar {
    width: 80px;
    height: 80px;
    border-width: 3px;
  }

  .intro-content h1 {
    font-size: var(--font-size-lg);
  }

  .intro-text {
    font-size: var(--font-size-sm);
  }

  .intro-start-btn {
    padding: 14px 24px;
    font-size: var(--font-size-sm);
  }

  /* 답변 버튼 - 세로 스택 */
  .answers {
    gap: 8px;
  }

  .answers > button {
    flex: 1 1 100%;
    height: 48px;
    font-size: var(--font-size-sm);
    border-radius: 12px;
  }

  .option-indicator {
    width: 20px;
    height: 20px;
    font-size: var(--font-size-xs);
  }

  .next-btn {
    padding: 10px 20px;
    font-size: var(--font-size-sm);
  }

  /* 힌트 */
  .hint-btn {
    width: 44px;
    height: 44px;
    font-size: 22px;
    right: 12px;
    bottom: 12px;
  }

  .hint-card {
    padding: 20px;
    border-radius: 16px;
  }

  .hint-header i {
    font-size: 24px;
  }

  .hint-header h2 {
    font-size: var(--font-size-base);
  }

  .hint-card p {
    font-size: var(--font-size-sm);
  }

  /* 결과 */
  .result-header i {
    font-size: 28px;
  }

  .result-header h2 {
    font-size: var(--font-size-lg);
  }

  .result-list {
    max-height: 220px;
    gap: 8px;
  }

  .result-item {
    padding: 12px;
    gap: 10px;
  }

  .q-label {
    width: 24px;
    height: 24px;
    font-size: var(--font-size-xs);
  }

  .result-q {
    font-size: var(--font-size-xs);
  }

  .result-a {
    font-size: var(--font-size-sm);
  }

  .result-actions {
    flex-direction: column;
    gap: 8px;
  }

  .result-btn {
    height: 44px;
    font-size: var(--font-size-sm);
  }
}
</style>